export default __webpack_public_path__ + "russell.c98994e4.jpg";